/* eslint-disable react-hooks/exhaustive-deps */
import { ChainId } from '@netswap/sdk'
import { NETWORK_CHAIN_ID } from 'connectors'
import getBoostedFarmPools from 'gql/microservices/boost-farm-pools'
import { useActiveWeb3React } from 'hooks'
import { useEffect, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'state'
import { setPools } from '../index'

export default function useGetBoostedFarmPools() {
  const { chainId } = useActiveWeb3React()
  const dispatch = useAppDispatch()
  const { pools } = useAppSelector((state) => state.boostedFarm)
  async function getPoolsData() {
    const res = await getBoostedFarmPools()
    const cid = chainId || NETWORK_CHAIN_ID
    if (res) {
      dispatch(
        setPools({
          chainId: cid,
          data: res,
        })
      )
    }
  }

  useEffect(() => {
    getPoolsData()
    let interval = setInterval(() => {
      getPoolsData()
    }, 30000)

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [chainId])

  return useMemo(() => {
    return pools && pools[(chainId || NETWORK_CHAIN_ID) as ChainId]
      ? pools[(chainId || NETWORK_CHAIN_ID) as ChainId]
      : []
  }, [pools, chainId])
}

export function useGetBoostedFarmPoolById(id: string) {
  const pools = useGetBoostedFarmPools()

  return useMemo(() => {
    return pools.find((item) => item.id === id)
  }, [id, pools])
}
